export const ACTIVITY_CREATOR_INTERACTIONS = 'activityCreatorInteractions';
export const ACTIVITY_CREATOR_FILE_INTERACTIONS = 'activityCreatorFileInteractions';
export const ACTIVITY_CREATOR_REORDER_INTERACTIONS = 'activityCreatorReorderInteractions';
export const BIZOPS_INTERACTION = 'bizops-interaction';
export const CREATE_ENGAGEMENT_ACTIVATION = 'createEngagementActivation';
export const CRM_DEBUG = 'crm-debug';
export const CRM_ERROR_BOUNDARY = 'crmErrorBoundary';
export const CRM_ONBOARDING = 'crm-onboarding';
export const ENGAGEMENT_USAGE = 'engagementUsage';
export const INDEX_INTERACTION = 'index-interaction';
export const INTERNAL_CRM_TRACKING = 'internal-crm-tracking';
export const RECORD_INTERACTION = 'record-interaction';
export const SETTINGS_INTERACTION = 'settings-interaction';

// CrmUsageTracker event name mappings (crm, settingsui, lists, tasks)
export const CRM_USAGE_TRACKER_EVENT_NAME_MAP = {
  tasks: {
    createTaskFromUI: 'Create Task From UI',
    taskQueueBarInteraction: 'Task Queue Bar Interaction',
    unassociatedTaskModalInteraction: 'Unassociated Task Modal Interaction'
  },
  crm: {
    'view-indexinteraction': 'Index Interaction',
    'view-recordinteraction': 'Record Interaction',
    individualEmailThreadInteraction: 'Record Interactions',
    createRecord: 'Create Record',
    createRecordActivation: 'Create First Record',
    createEngagementActivation: 'Create First Engagement',
    crmActivation: 'CRM Activation',
    debugChunkLoadIssues: 'CRM Debug',
    crmErrorBoundary: 'CRM Error Boundary',
    exportView: 'Index Interaction',
    emailCommunicatorInteraction: 'Record Interaction',
    indexUsage: 'Index Interaction',
    indexPageActivation: 'First View CRM Index',
    savedFilterActivation: 'Load First Saved Filter',
    useFilters: 'Index Interaction',
    recordUsage: 'Record Interaction',
    playbookInteraction: 'Playbook Interaction',
    openIntegrationIframeInTimeline: 'Record Interaction',
    timelineCardInteraction: 'Record Interaction',
    timelineCommentsUsage: 'Timeline Usage',
    timelineUsage: 'Timeline Usage',
    timelineInteraction: 'Timeline Interactions',
    timelineEmailThreadInteraction: 'Timeline Interactions',
    timelineExpandCollapseInteraction: 'Timeline Interactions',
    sidebarInteraction: 'Record Interaction',
    previewSidebarObject: 'Sidebar Interaction',
    ticketsActivation: 'Tickets Activation',
    ticketsDayZero: 'Tickets Day Zero',
    'virality-sent-email-with-brand-banner': 'Virality',
    'virality-removed-brand-banner': 'Virality',
    createTask: 'Create Task',
    completedTask: 'Complete Task',
    finishTaskQueueActivation: 'Finish First Task Queue',
    sentFirstCrmEmail: 'Sent First CRM Email',
    selectedActionsRedesignOption: 'Activity Interaction',
    communicationSubscriptionCardInteraction: 'Record Interactions',
    associateSidebarInteraction: 'Record Interaction',
    timelineShowDetailsInteraction: 'Timeline Interactions',
    timelineUsageDetailsInteraction: 'Timeline Usage',
    timelineEngagementInteraction: 'Timeline Usage',
    timelineEditEventInteraction: 'Timeline Usage',
    pageRefresh: 'Refresh',
    propertyEditorInteraction: 'Record Interactions',
    aboutCardUsage: 'Record Usage',
    recordHighlightInteraction: 'Record Interactions',
    recordHighlightUsage: 'Record Usage',
    recordPageView: 'Record Pageview',
    savedProperties: 'Saved Properties',
    communicatorFullScreenOpenInteractionV2: 'Activity Interaction',
    timelineInteractions: 'Timeline Interactions',
    timelineThreadInteractions: 'Timeline Interactions',
    recordInteractions: 'Record Interactions',
    cardInteractions: 'Card Interactions',
    engagementUsage: 'Create Engagement',
    engagementInteraction: 'Create Engagement',
    activityCreatorInteractions: 'Activity Creator Interactions',
    activityCreatorReorderInteractions: 'Activity Creator Interactions',
    activityCreatorFileInteractions: 'Activity Creator Interactions',
    useMention: 'Use Mention',
    changeTicketStatusToClosedInRecord: 'Change Ticket Status To Closed In Record',
    changeTicketStatusToOpenInRecord: 'Change Ticket Status To Open In Record',
    deleteRecord: 'Delete Record',
    addAssociation: 'Add Association',
    removeAssociation: 'Remove Association',
    universalAssociationsSelect: 'Universal Associations Select',
    marketableContactsCheckboxInteraction: 'Record Interactions',
    'bizops-interaction': 'Bizops Interaction',
    'internal-crm-tracking': 'Internal CRM Tracking',
    'crm-onboarding': 'CRM Onboarding',
    'crm-debug': 'CRM Debug',
    'index-interaction': 'Index Interaction',
    'record-interaction': 'Record Interaction',
    'saved-properties': 'Saved Properties',
    'sidebar-interaction': 'Sidebar Interaction',
    pageview: 'Pageview',
    'use-bulk-double-opt-in': 'Use Bulk Double Opt In',
    'sample-contact-failure': 'Sample Contact Failure',
    indexInteractions: 'Index Interactions',
    filterUsage: 'Filter Usage',
    filterInteractions: 'Filter Interactions',
    useLocalSearch: 'Use Local Search',
    createSavedView: 'Create Saved View',
    createSavedForecastView: 'Create Saved Forecast View',
    openForecastSubmissionPanel: 'Open Forecast Submission Panel',
    editSavedView: 'Edit Saved View',
    openSavedView: 'Open Saved View',
    exportSavedView: 'Export View',
    movedBoardColumnItem: 'Moved Board Column Item',
    editColumns: 'Edit Columns',
    bulkAssign: 'Bulk Assign',
    bulkEditRecords: 'Bulk Edit Records',
    bulkDelete: 'Bulk Delete',
    indexPageview: 'Index Pageview',
    saveBulkCommunicationSubscription: 'Save Bulk Communication Subscription',
    marketingEventsOptInModal: 'Marketing Events Opt In Modal',
    transcriptQuickfilter: 'Transcript Quickfilter',
    inlineEditing: 'Inline Editing',
    'inserted-content-from-popover': 'Inserted Content From Popover',
    'inserted-snippet': 'Inserted Snippet',
    'use-android-app-installprompt': 'Use Android App Installprompt',
    'use-bulk-add-to-list': 'Use Bulk Add To List',
    'use-bulk-create-tasks': 'Use Bulk Create Tasks',
    'use-bulk-enroll-in-sequence': 'Use Bulk Enroll In Sequence',
    'use-bulk-enroll-in-workflow': 'Use Bulk Enroll In Workflow',
    'use-bulk-remove-from-list': 'Use Bulk Remove From List',
    'use-linked-sales-object-iframe': 'Use Linked Sales Object Iframe',
    'use-sequence-timeline-edit': 'Use Sequence Timeline Edit'
  },
  settingsui: {
    settingsInteractionWithType: 'Settings Interaction',
    settingsInteractionWithSuccess: 'Settings Interaction',
    saveBoardCardCustomizationSettings: 'Save Board Card Customization Settings',
    'deal-pipeline-saved': 'Deal Pipeline Saved',
    'deal-pipeline-created': 'Deal Pipeline Created',
    'lifecycle-stage-automation-setting-changed': 'Lifecycle Stage Automation Setting Update',
    'lifecycle-stage-saved': 'Lifecycle Stage Saved',
    'ticket-pipeline-saved': 'Ticket Pipeline Saved',
    'ticket-pipeline-created': 'Ticket Pipeline Created',
    'deal-stage-created': 'Deal Stage Created',
    'ticket-stage-created': 'Ticket Stage Created',
    'settings-usage': 'Settings Usage',
    'settings-navigation': 'Settings Navigation',
    'contact-settings-pageview': 'Contact Settings Pageview',
    'company-settings-pageview': 'Company Settings Pageview',
    'deal-settings-pageview': 'Deal Settings Pageview',
    'ticket-settings-pageview': 'Ticket Settings Pageview',
    'import-export-pageview': 'Import Export Pageview',
    'settings-interaction': 'Settings Interaction',
    'settings-email-plugin-check-retry-clicked': 'Settings Email Plugin Check Retry Clicked',
    'settings-enable-company-autocreate': 'Settings Enable Company Autocreate',
    'settings-import-export-clicked-import-button': 'Settings Import Export Clicked Import Button',
    'settings-start-company-autocreate-backfill': 'Settings Start Company Autocreate Backfill',
    'view-settings-calling': 'View Settings Calling',
    'view-settings-companies': 'View Settings Companies',
    'view-settings-config': 'View Settings Config',
    'view-settings-contacts': 'View Settings Contacts',
    'view-settings-deals': 'View Settings Deals',
    'view-settings-email': 'View Settings Email',
    'view-settings-importexport': 'View Settings Import Export',
    'view-settings-notifications': 'View Settings Notifications',
    'view-settings-privacy': 'View Settings Privacy',
    'view-settings-supportForm': 'View Settings Support Form',
    'view-settings-salestools': 'View Settings Sales Tools',
    'view-settings-tasks': 'View Settings Tasks',
    'view-settings-tickets': 'View Settings Tickets'
  },
  lists: {
    createReport: 'Create Report',
    editListColumns: 'Edit Columns',
    createList: 'Create List',
    deleteList: 'Delete List',
    updateList: 'Update List',
    createFolder: 'Create Folder',
    deleteFolder: 'Delete Folder',
    moveToFolder: 'Move To Folder',
    listsPageview: 'Pageview',
    listsInteraction: 'Lists Interaction',
    addContactsToRestrictedList: 'Lists Interaction',
    bulkAddToList: 'Bulk Add To List',
    'view-listcreate': 'View List Create',
    'view-listdetail': 'View List Detail',
    'view-listsindex': 'View Lists Index'
  }
};

// CommunicatorLogger event name mappings
export const COMMUNICATOR_EVENT_NAME_MAP = {
  communicatorInteraction: 'Communicator Interaction',
  communicator_fileInteraction: 'Communicator Interaction',
  communicator_bannerInteraction: 'Banner Interaction',
  communicatorUsage_createFollowUpTask: 'Create Followup Task',
  communicator_emailActivation: 'Email Activation',
  communicator_firstEmailActivation: 'First Email Activation',
  communicator_timelineInteraction: 'Timeline Interaction',
  communicator_formatText: 'Communicator Interaction',
  communicator_saveSignature: 'Communicator Interaction',
  communicator_recipientInteraction: 'Communicator Interaction',
  communicator_sendEmail: 'Communicator Interaction',
  communicatorUsage_sendEmail: 'Send Email'
};

// LineItemsLogger event name mappings
export const LINE_ITEMS_EVENT_NAME_MAP = {
  addLineItem: 'Lineitems Interaction',
  editLineItem: 'Lineitems Interaction',
  removeLineItem: 'Lineitems Interaction',
  reorderLineItem: 'Lineitems Interaction',
  selectInvalidCurrencyResolutionOption: 'Lineitems Interaction',
  resolveInvalidCurrencies: 'Lineitems Interaction',
  cancelStagedLineItemChanges: 'Lineitems Interaction',
  goToLineItemEditorFromRecordCard: 'Lineitems Interaction',
  goToDealFromLineItemEditor: 'Lineitems Interaction',
  editGlobalTerms: 'Lineitems Interaction',
  openGlobalTermsModal: 'Lineitems Interaction',
  openEditColumnsModal: 'Lineitems Interaction',
  clickTableCell: 'Lineitems Interaction',
  addLineItemsPanelFilter: 'Lineitems Interaction',
  clickAddLineItemFromZeroState: 'Lineitems Interaction',
  addLineItemsPanelInteractions: 'Lineitems Interaction',
  lineItemValidation: 'Lineitems Interaction',
  editLineItemTiers: 'Lineitems Interaction',
  saveProductFromLineItem: 'Lineitems Usage',
  bulkSaveLineItems: 'Lineitems Usage',
  updateDealAmount: 'Lineitems Usage',
  updateLineItemTableColumns: 'Lineitems Usage',
  updateLineItemTableColumnWidth: 'Lineitems Usage',
  cancelLineItemTableColumnsUpdate: 'Lineitems Usage',
  viewLineItems: 'Pageview'
};

// ProductsLogger event name mappings
export const PRODUCTS_EVENT_NAME_MAP = {
  openProductOrLineItemPanel: 'Products Interaction',
  toggleFilePickerForImageURL: 'Products Interaction',
  selectFileForImageURL: 'Products Interaction',
  productLibraryFilter: 'Products Interaction',
  productPaymentLinkModalInteraction: 'Products Interaction',
  createObjectFromProductModal: 'Products Interaction',
  productsSetup: 'Products Interaction',
  editProductTiers: 'Products Interaction',
  productPanelUsage: 'Product Panel',
  productExport: 'Products Export',
  deleteObject: 'Products Usage',
  bulkDeleteObjects: 'Products Usage',
  modifyFolderModal: 'Products Usage',
  moveProductToFolder: 'Products Usage'
};

// ReportingLogger event name mappings
export const REPORTING_EVENT_NAME_MAP = {
  embeddedReportView: 'Embedded Report View',
  embeddedReportInteraction: 'Embedded Report Interaction'
};

// SubscriptionTracker event name mappings
export const COMMERCE_SUBSCRIPTION_EVENT_NAME_MAP = {
  interactionEvent: 'Interaction Event',
  usageEvent: 'Usage Event',
  subscriptionChange: 'Subscription Change',
  subscriptionUpsert: 'Subscription Upsert'
};